import { validateTidalLicense } from "../../base/index.js";
import { removeNonWord } from "./removeNonWord.js";
import { replaceAccents } from "./replaceAccents.js";
import { lowerCase } from "./utils/lowerCase.js";
import { upperCase } from "./utils/upperCase.js";
function camelCase(str) {
  return removeNonWord(replaceAccents(str)).replace(/-/g, " ").replace(/\s[a-z]/g, upperCase).replace(/\s+/g, "").replace(/^[A-Z]/g, lowerCase);
}
validateTidalLicense();
export {
  camelCase
};
//# sourceMappingURL=camelCase.js.map
